import { z } from "zod";
const seconds = z.number().finite().nonnegative();
export const wordSchema = z.object({
    text: z.string(),
    start: seconds,
    end: seconds,
    confidence: z.number().min(0).max(1).nullable(),
});
export const segmentSchema = z.object({
    id: z.number().int().nonnegative(),
    start: seconds,
    end: seconds,
    speaker: z.string().nullable(),
    text: z.string(),
    words: z.array(wordSchema),
});
export const cueSchema = z.object({
    id: z.number().int().nonnegative(),
    start: seconds,
    end: seconds,
    lines: z.array(z.string()),
    speaker: z.string().nullable().optional(),
});
export const transcriptSchema = z.object({
    version: z.literal(1),
    language: z.literal("sq"),
    model: z.string().min(1),
    duration: seconds,
    text: z.string(),
    segments: z.array(segmentSchema),
    captions: z.array(cueSchema).nullable(),
});
